module.exports = __webpack_public_path__ + "img/how-delete.9a6a8186.png";